import React from 'react';
import { useField } from 'formik';
import Select from 'react-select';

import { Icon } from 'client/components/common';
import Error from 'client/components/common/Error';

import css from './SchedulePopup.module.scss';

interface Option {
  label: string;
  value: number;
}

interface Props {
  name: string;
  placeholder?: string;
  options: Option[];
}

export const SelectComponent: React.FC<Props> = (props) => {
  const { name, placeholder, options } = props;
  const [, meta, helpers] = useField(name);
  const errorMsg = !!(meta.touched && meta.error) ? meta.error : '';

  return (
    <div className={css.select}>
      <Select
        options={options}
        id={name}
        instanceId={name}
        placeholder={placeholder}
        classNamePrefix="rs"
        components={{
          DropdownIndicator: () => <Icon type="down-white-arrow" className={css.dropdownIndicator} />,
        }}
        onChange={(e) => {
          if (e && e.value) {
            helpers.setValue(e?.value);
          }
        }}
      />
      {errorMsg && meta.touched && <Error name={name} error={errorMsg} />}
    </div>
  );
};
